var cov_2h1s24m0c2 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/styles/expose.js",
      hash = "0a7d2f93ae92b9c86f6271a73b8b0e72e9bc72e4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/styles/expose.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 4,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var exposeLess = {};
import genaration from '../utils/classname';
export var exposeClass = (cov_2h1s24m0c2.s[0]++, genaration(exposeLess, 'expose'));